export function decodeToken(token: string) {
  const [header, payload, signature] = token.split(".");

  const decodedHeader = base64DecodeUrlSafe(header);
  const decodedPayload = base64DecodeUrlSafe(payload);
  const parsedHeader = JSON.parse(decodedHeader);
  const parsedPayload = JSON.parse(decodedPayload);

  return {
    header: parsedHeader,
    payload: parsedPayload,
    signature: signature,
  };
}

export function base64DecodeUrlSafe(str: string) {
  const base64Str = str.replace(/-/g, "+").replace(/_/g, "/");
  const decodedStr = atob(base64Str);
  return decodedStr;
}
